// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function TisTechnical(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h3", {
        children: "Технические сведения",
        className: "h4 lg:h3 text-center text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "ТИС Бухта состоит из Центрального узла ТИС и Клиентского модуля ТИС. Обеспечивает следующий функционал:",
        className: "paragraph-large lg:h-light text-center text-black-landing lg:flex lg:mx-auto mt-2 lg:w-178.75"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("h6", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "inline mr-4 w-8.25",
                    src: StaticAsset.src("/static/icons/card-black.svg")
                  }),
                  "Безналичный платеж"
                ],
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Прием безналичных платежей посредством системы для приема безналичных платежей.",
                className: "paragraph lg:paragraph-large text-gray-landing ml-12 lg:mt-2.5"
              }),
              JsxRuntime.jsxs("h6", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "inline mr-4",
                    src: StaticAsset.src("/static/icons/xreport.svg")
                  }),
                  "ОФД"
                ],
                className: "h6 text-black-landing mt-4 lg:mt-10"
              }),
              JsxRuntime.jsx("p", {
                children: "Подключение к оператору фискальных данных Республики Казахстан по протоколу передачи данных и передачи оператору фискальных данных Республики Казахстан сведений о денежных расчетах, осуществляемых налогоплательщиком при реализации товаров, работ, услуг посредством ККМ «Аппаратно-программный комплекс «Бухта 1.0», являющейся частью ТИС.",
                className: "paragraph lg:paragraph-large text-gray-landing ml-12 lg:mt-2.5"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/visa.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "ml-4",
                    src: StaticAsset.src("/static/icons/mastercard.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "ml-4",
                    src: StaticAsset.src("/static/icons/mir.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "ml-4",
                    src: StaticAsset.src("/static/icons/union-pay.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "ml-4",
                    src: StaticAsset.src("/static/icons/jcb.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "ml-4",
                    src: StaticAsset.src("/static/icons/amex.svg")
                  })
                ],
                className: "flex ml-12 items-center lg:mt-2"
              })
            ],
            className: "lg:w-96"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("h6", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "inline mr-4 w-8.25",
                    src: StaticAsset.src("/static/icons/docs-black.svg")
                  }),
                  "Документы"
                ],
                className: "h6 text-black-landing mt-8 lg:mt-0"
              }),
              JsxRuntime.jsx("p", {
                children: "Формирование документов в ТИС, применяемых для оформления операций или событий.",
                className: "paragraph lg:paragraph-large text-gray-landing ml-12 lg:mt-2.5"
              }),
              JsxRuntime.jsxs("h6", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "inline mr-4",
                    src: StaticAsset.src("/static/icons/report.svg")
                  }),
                  "ЭСФ"
                ],
                className: "h6 text-black-landing mt-4 lg:mt-10"
              }),
              JsxRuntime.jsx("p", {
                children: "Формирование, прием и использование электронных счетов-фактур с подключением к информационной системе «Электронные счета-фактуры».",
                className: "paragraph lg:paragraph-large text-gray-landing ml-12 lg:mt-2.5"
              }),
              JsxRuntime.jsxs("h6", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "inline mr-4",
                    src: StaticAsset.src("/static/icons/guard.svg")
                  }),
                  "Контроль данных"
                ],
                className: "h6 text-black-landing mt-4 lg:mt-10"
              }),
              JsxRuntime.jsx("p", {
                children: "Контроль полноты вводимых данных - в случае выполнения функций или операций без полного заполнения всех полей, система уведомляет пользователя соответствующим уведомлением.",
                className: "paragraph lg:paragraph-large text-gray-landing ml-12 lg:mt-2.5"
              })
            ],
            className: "lg:w-96"
          })
        ],
        className: "lg:flex lg:m-auto mt-10 lg:mt-20 justify-between lg:w-200"
      }),
      JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
        classes: {
          hd: "flex m-auto mt-10 lg:mt-20",
          tl: /* [] */ 0
        },
        label: Buhta_landing__I18n.trans(intl, "start_using"),
        onClick: (function (param) {
          Buhta_landing__EventHandlers.scrollToFooter(deviceType);
        })
      }),
      JsxRuntime.jsx("p", {
        children: "Уже пользуются 125 предпринимателей",
        className: "paragraph-small text-center text-gray-landing mt-4"
      })
    ],
    className: "py-10 px-6 lg:pt-40 lg:pb-20 sm:px-48 lg:px-0"
  });
}

const make = TisTechnical;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
